import { useTranslation } from "react-i18next";

export default function ReviewSubmitStep({ formData, onSubmit, loading, error }) {
  const { t } = useTranslation();

  const renderItem = (labelKey, value) => {
    if (!value || value.trim() === "") return null;

    return (
      <li>
        <strong>{t(labelKey)}:</strong> {value}
      </li>
    );
  };

  return (
    <>
      <h2>{t("Start.schoolInfo")}</h2>

      <ul>
        {/* Required */}
        {renderItem("Start.schoolName", formData.schoolName)}
        {renderItem("Start.directorName", formData.directorName)}
        {renderItem("Start.schoolAddress", formData.schoolAddress)}
        {renderItem("Start.schoolEmail", formData.schoolEmail)}
        {renderItem("Start.adminEmail", formData.adminEmail)}
        {renderItem("Start.desiredURL", formData.desiredURL)}

        {/* Optional */}
        {renderItem("Start.additionalAdminEmails", formData.additionalAdmins)}
        {renderItem("Start.phoneNumber", formData.phoneNumber)}
        {renderItem("Start.schoolWebsite", formData.website)}
        {renderItem("Start.facebookURL", formData.facebookUrl)}
        {renderItem("Start.instagramURL", formData.instagramUrl)}
        {renderItem("Start.notes", formData.notes)}
      </ul>


      {error && (
        <p className="error">
          {t("Start.errors.submitFailed")}
        </p>
      )}

      <button
        className="submit"
        onClick={onSubmit}
        disabled={loading}
      >
        {loading ? t("Start.sending") : t("Start.send")}
      </button>
    </>
  );
}
